import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import Masonry from 'react-masonry-component';
import PostListItem from '../post-list-item';
import CreatePostCta from '../create-post-cta';
import { CARD_SIZE_SMALL, CARD_SIZE_MEDIUM, CARD_SIZE_LARGE } from '../../constants/card-sizes';
import { CARD_SIZE_PATH } from '../../constants/wix-params';
import withAppSettings from '../../hoc/with-app-settings';
import styles from './post-list.scss';

const TYPES = {
  [CARD_SIZE_SMALL]: 'small',
  [CARD_SIZE_MEDIUM]: 'medium',
  [CARD_SIZE_LARGE]: 'large',
};

const MASONRY_OPTIONS = {
  transitionDuration: 0,
  fitWidth: false,
  gutter: 20,
};

const PostListMasonry = ({ category, posts, cardSize, onLikeClick, showCreatePostAction }) => {
  const type = TYPES[cardSize];
  const className = classNames(styles.masonry, styles[type]);
  return (
    <Masonry className={className} options={MASONRY_OPTIONS} data-hook="post-list">
      {showCreatePostAction &&
        <div className={classNames(styles.listItem)} key="create-post">
          <CreatePostCta categorySlug={category.slug}/>
        </div>}
      {posts.map(post =>
        <div
          className={classNames(styles.listItem, 'post-list__post-list-item')}
          key={post._id}
          id={post._id}
          data-hook="post-list-item"
        >
          <PostListItem type={type} post={post} onLikeClick={onLikeClick}/>
        </div>
      )}
    </Masonry>
  );
};

PostListMasonry.propTypes = {
  onLikeClick: PropTypes.func.isRequired,
  category: PropTypes.object,
  posts: PropTypes.array,
  query: PropTypes.string,
  cardSize: PropTypes.number,
  showCreatePostAction: PropTypes.bool,
};

PostListMasonry.defaultProps = {
  cardSize: CARD_SIZE_MEDIUM,
};

export default withAppSettings({
  cardSize: CARD_SIZE_PATH,
})(PostListMasonry);



// WEBPACK FOOTER //
// ./app/components/post-list/post-list-masonry.js